import { DownloadArrow } from '#assets/ReactSvg.ts';
import { IconButton } from '#components/atoms/buttons/icon/icon-button/IconButton.tsx';
import { Tooltip } from '#components/atoms/tooltip/Tooltip.tsx';
import { DebugCommandMenu, type CommandModal } from '../DebugCommandMenu.tsx';

type Props = {
  supportedCommands: string[];
  onStartStream?: () => void;
  onDebugStack: () => void;
  setCommandModal: (modalName: CommandModal) => void;
  onDownload?: () => void;
};

export function DebugButtons({ supportedCommands, onDownload, setCommandModal, onStartStream, onDebugStack }: Props) {
  return (
    <div className="flex">
      {onDownload ?
        <Tooltip content="Download logs">
          <IconButton title="Download logs" onClick={onDownload}>
            <DownloadArrow />
          </IconButton>
        </Tooltip>
      : null}
      <Tooltip content="Debug commands">
        <DebugCommandMenu
          variant="icon"
          supportedCommands={supportedCommands}
          setCommandModal={setCommandModal}
          onStartStream={onStartStream}
          onDebugStack={onDebugStack}
        />
      </Tooltip>
    </div>
  );
}
